module.exports = __webpack_public_path__ + "img/support.d742a012.svg";